export const GLOBAL_ERROR = 'error.global.title'
